import React from 'react';

/**
 * "Quantum Neural Network" thinking indicator — a small (20px), refined loading state
 * for anywhere the agent is actively working. Purely CSS-driven (styles/app.css), so this
 * component is just markup; the same markup/CSS pair is mirrored in admin-console.html for
 * the admin chat, which isn't a React app and can't import this file directly.
 */
export default function ThinkingIndicator({ label = 'Thinking\u2026' }) {
  return (
    <div className="thinking-indicator" role="status" aria-live="polite" aria-label={label}>
      <div className="ti-orbit">
        <div className="ti-glow-bg" />
        <svg className="ti-lines" viewBox="0 0 20 20" aria-hidden="true">
          <line x1="10" y1="2" x2="3.5" y2="16.5" />
          <line x1="3.5" y1="16.5" x2="16.5" y2="16.5" />
          <line x1="16.5" y1="16.5" x2="10" y2="2" />
        </svg>
        <span className="ti-dot ti-dot-1" />
        <span className="ti-dot ti-dot-2" />
        <span className="ti-dot ti-dot-3" />
      </div>
      <span className="ti-text">{label}</span>
    </div>
  );
}
